"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = exports.Modal = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var faTimes_1 = require("@fortawesome/free-solid-svg-icons/faTimes");
var classnames_1 = __importDefault(require("classnames"));
var Button_1 = require("../Button/Button");
var Modal = function (props) {
    var className = props.className, children = props.children, dismissWithCloseButtonOnly = props.dismissWithCloseButtonOnly, onClose = props.onClose;
    var closeModal = function () { return onClose(); };
    var modal = (0, react_1.useRef)(null);
    var handleClick = function (e) {
        if (e.target !== modal.current || dismissWithCloseButtonOnly)
            return;
        closeModal();
    };
    return (react_1.default.createElement(ModalWrapper, { className: (0, classnames_1.default)('man-ui', className), ref: modal, onClick: handleClick },
        react_1.default.createElement(exports.CloseButton, { onClick: closeModal },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faTimes_1.faTimes })),
        children));
};
exports.Modal = Modal;
var ModalWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.4);\n  position: fixed;\n  z-index: 1000;\n  transition: 0.3s opacity ease;\n  top: 0px;\n"], ["\n  width: 100%;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.4);\n  position: fixed;\n  z-index: 1000;\n  transition: 0.3s opacity ease;\n  top: 0px;\n"])));
exports.CloseButton = (0, styled_components_1.default)(Button_1.Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: transparent;\n  width: 35px;\n  height: 35px;\n  border: none;\n  font-size: 1.43rem;\n  outline: none;\n  box-shadow: none;\n"], ["\n  cursor: pointer;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: transparent;\n  width: 35px;\n  height: 35px;\n  border: none;\n  font-size: 1.43rem;\n  outline: none;\n  box-shadow: none;\n"])));
exports.default = exports.Modal;
var templateObject_1, templateObject_2;
